import { KEVEL_ID, SPONSORED_CLICK_URL } from '@common/Tracking/constants/localStorage';
import { remove } from '@helpers/localStorage';

export const removeSponsoredTrackingData = () => {
    remove(SPONSORED_CLICK_URL);
    remove(KEVEL_ID);
};
